export const MODAL_TYPE_READONLY_MODE_OWNER = 'readonly-mode-modal-owner';
